import { match } from 'ts-pattern';

import type { BillingStatus } from './get-billing-status';

export type BillingStatusBadge = { label: string; variant: 'warning' | 'destructiveSoft' };

export const getBillingStatusBadge = (status: BillingStatus): BillingStatusBadge | null =>
    match(status)
        .with('cancelling', () => ({
            label: 'Cancellation Scheduled',
            variant: 'warning' as const,
        }))
        .with('canceled', () => ({
            label: 'Account deletion scheduled',
            variant: 'destructiveSoft' as const,
        }))
        .with('past-due', () => ({ label: 'Payment Failed', variant: 'destructiveSoft' as const }))
        .with('active', () => null)
        .exhaustive();
